import type { ColumnSort } from "@tanstack/react-table"
import { useMemo, useRef, useState } from "react"

import { idsToTableSelectedRowFormat } from "@/components/Tables/Aeros/utils"
import type { Instruction } from "@/graphql/codegen/graphql"

interface UseInstructionTableOptionsReturn {
  instructionsToAssociate: string[]
  selectedInstructions: React.MutableRefObject<Instruction[]>
  selected: Record<string, boolean>
  setSelected: React.Dispatch<React.SetStateAction<Record<string, boolean>>>
  sorting: ColumnSort[]
  setSorting: React.Dispatch<React.SetStateAction<ColumnSort[]>>
}

const useInstructionTableActionOptions = ({
  associatedInstructionIds,
}: {
  associatedInstructionIds: string[]
}): UseInstructionTableOptionsReturn => {
  // All selected instructions in the table (newly added and already associated)
  const [selected, setSelected] = useState<Record<string, boolean>>(
    idsToTableSelectedRowFormat(associatedInstructionIds)
  )

  // Newly added instructions (to be submitted)
  const instructionsToAssociate = useMemo(() => {
    const selectedInstructionIds = Object.keys(selected)
    // Filter out already associated instructions
    return selectedInstructionIds.filter((id) => !associatedInstructionIds.includes(id))
  }, [associatedInstructionIds, selected])

  const selectedInstructions = useRef<Instruction[]>([])
  const [sorting, setSorting] = useState<ColumnSort[]>([
    {
      id: "name",
      desc: false,
    },
  ])

  return {
    instructionsToAssociate,
    selectedInstructions,
    selected,
    setSelected,
    sorting,
    setSorting,
  }
}

export default useInstructionTableActionOptions
